<template>
    <section class="QuizMultiplePath ContentSection">

        <!-- quiz -->
        <div class="QuizMultiplePath__quiz" v-if="!quizComplete">

            <div class="QuizMultiplePath__quiz__question">
                <h5 v-html="combinedQuestionString"></h5>
            </div>

            <div class="QuizMultiplePath__quiz__answers">
                <transition-group @enter="onQuestionEnter" @before-enter="onBeforeQuestionEnter"
                    @leave="onQuestionLeave" name="list" appear>
                    <button v-for="answer, i in currentQuestion.filteredAnswers" :key="answer.text" :data-index="i"
                        @click="answerQuestion(answer)">{{ answer.text }}</button>
                </transition-group>
            </div>

            <div class="QuizMultiplePath__quiz__bottomnav">
                <span class="progress" v-html="quizProgress"></span>
            </div>

        </div>

        <!-- results -->
        <div class="QuizMultiplePath__results" v-else>



            <div v-if="finalResult">

                <h5 v-html="properties.resultTitle"></h5>

                <!-- accordion -->
                <div class="QuizMultiplePath__results_accordion">

                    <article v-for="accordion in finalResult.resultElements" :key="accordion.title">
                        <button @click="openAccordionClick(accordion)">

                            {{ accordion.title }}
                            <img src="@/assets/img/ui/accordion-plus.svg" v-if="!accordion.open" />
                            <img src="@/assets/img/ui/accordion-close.svg" v-else />
                        </button>

                        <div v-if="accordion.open">
                            <div v-html="accordion.text" class="AccordionInfo__text"></div>
                        </div>
                    </article>

                </div>

                <div class="QuizMultiplePath__results_links">
                    <a class="hyperLink" v-for="link in finalResult.links" :href="link.linkUrl" target="_blank">
                        <div>
                            <img src="@/assets/img/ui/btn-arrow.svg" />
                        </div>
                        {{ link.linkText }}
                    </a>
                </div>

            </div>

            <!-- results with combinaition not existing -->
            <div v-else>
                <h5 v-html="combinedQuestionString"></h5>
                <p>(Intet resultat har resultPath <b>{{ resultPath }})</b></p>
            </div>

            <!-- try again  -->
            <p>
                <a class="Button" @click="retryQuiz()">Prøv igen</a>
            </p>
        </div>



    </section>
</template>
<script>
import gsap from 'gsap';
// import PDFGenerator from '../util/PDFGenerator.vue';
export default {
    props: ["properties", "pageData"],
    components: {
        // PDFGenerator
    },
    data() {
        return {
            activeQuestion: 0,
            questions: [],
            combinedQuestionString: "",
            results: [],
            quizComplete: false,
            resultsHTML: null,
            resultPath: "",

            finalResult: {}
        };
    },
    created() {
        this.initQuiz();
    },
    methods: {

        initQuiz() {

            this.resultPath = "";

            this.questions = this.properties.questions.map((question, i) => {
                question.id = `q__${i}`;
                return question;
            });

            this.results = this.properties.results.map((result, i) => {
                return result;
            });

            this.combinedQuestionString = this.questions[0].question;
            this.quizComplete = false;
            this.activeQuestion = 0;

        },


        // getFilteredAnswers(){


        // }

        answerQuestion(answer) {

            // no answer = skip!
            if (answer) {
                // add answers path to final resultpath
                this.resultPath = answer.answerPath;
            }

            this.combinedQuestionString = this.combinedQuestion(answer);

            // are we there yet?
            if (this.activeQuestion == this.questions.length - 1) {
                this.endQuiz();
                return;
            }

          //  if(this.activeQuestion === 0)
                // _paq.push(["trackEvent", "quiz", "quiz-started", window.app.vm.$route.path]);

            this.activeQuestion++;

        },



        endQuiz() {
            // find result
            this.finalResult = this.results.find(result => {
                return result.resultPath === this.resultPath
            })

            // _paq.push(["trackEvent", "quiz", "quiz-ended", window.app.vm.$route.path]);
            this.quizComplete = true;
        },
        
        
        combinedQuestion(answer) {
            {
                var qString = this.combinedQuestionString + " " + answer.text;
                qString = qString.split(".").join("");
                qString = qString.split("…").join("");
                qString += (this.activeQuestion >= this.questions.length - 1) ? ":" : "…";
                
                return qString;
            }
            
        },
        
        openAccordionClick(accordion) {
            let i = 0;
            while (i < this.finalResult.resultElements.length) {
                if (accordion.title !== this.finalResult.resultElements[i].title) {
                    this.finalResult.resultElements[i].open = false;
                } else {
                    accordion.open = !accordion.open
                }
                
                i++;
            }
        },
        
        
        
        
        // animations
        onBeforeQuestionEnter(el) {
            gsap.set(el, {
                opacity: 0,
                x: -20
            })
        },
        onQuestionEnter(el, done) {
            gsap.to(el, {
                duration: 0.5,
                opacity: 1,
                x: 0,
                delay: el.dataset.index * 0.2,
                onComplete: done
            })
        },
        onQuestionLeave(el, done) {
            gsap.set(el, {
                opacity: 0,
                onComplete: done
            })
        },
        retryQuiz() {
            // _paq.push(["trackEvent", "quiz", "quiz-retry", window.app.vm.$route.path]);
            this.initQuiz()
        }
    },
    computed: {
        currentQuestion() {
            
            
            //return this.questions[this.activeQuestion];

            // filtrer svarmuligheder udfra forrige valg 
            var cQ =  this.questions[this.activeQuestion];
            cQ.filteredAnswers = cQ.answers.filter(answer => answer.answerPath.includes(this.resultPath));
            
            return cQ;

        },

        quizProgress() {
            let currentSlide = (this.activeQuestion + 1).toString();
            let addPadding = currentSlide.length < 2 && this.questions.length >= 10;

            return `${addPadding ? "0" + currentSlide : currentSlide} | ${this.questions.length}`;
        }
    },
};
</script>


<style lang="scss">
@import '@/assets/sass/_responsiveness.scss';

.QuizMultiplePath {
    display: flex;
    align-items: center;
    flex-direction: column;
    flex-grow: 1;
    padding-top: 120px;
    padding-bottom: 120px;
    background: var(--light-grey);

    &>div {
        position: relative;
        display: block;

        width: 100%;
        max-width: var(--content-max-width);
        text-align: left;

        &.QuizMultiplePath__quiz {

            padding: var(--content-padding);

            .QuizMultiplePath__quiz__question {
                h5 {
                    padding: 0;
                }

                margin-bottom:50px;
            }

            .QuizMultiplePath__quiz__answers {
                button {

                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    height: 75px;
                    background-color: #fff;
                    margin-bottom: 20px;
                    width: 100%;
                    padding: 30px;
                    border-radius: 30px;
                    background-image: url(@/assets/img/ui/btn-arrow.svg);
                    background-position: right 20px bottom 50%;
                    background-repeat: no-repeat;
                    transition: transform 0.1s ease;

                    &:hover {
                        transform: scale(1.03) !important;
                    }
                }
            }

            .QuizMultiplePath__quiz__bottomnav {
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;

                button {
                    display: flex;
                    align-items: center;
                    cursor: pointer;

                    &>img {
                        margin-left: 14px;
                    }
                }

                .progress {
                    margin-left: 10px;
                    font-weight: bold;
                }
            }
        }

        &.QuizMultiplePath__results {
            flex-direction: column;
            text-align: left;
            padding-bottom: 30px;

            h5 {
                margin-bottom: 50px;

            }




            .QuizMultiplePath__results_accordion {
                width: 100%;
                max-width: var(--content-max-width);
                padding: var(--content-padding);


                &>article {
                    width: 100%;

                    border-bottom: solid 1px #000;

                    &:first-of-type {
                        border-top: solid 1px #000;
                    }

                    &>div {
                        padding: 10px 0 40px 0;
                    }

                    .AccordionInfo__text>p{
                        padding:0;
                    }

                    &>button {
                        position: relative;
                        display: flex;
                        align-items: center;
                        font-size: 16px;
                        font-weight: bold;
                        height: 70px;

                        &>span {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 24px;
                            height: 24px;
                            border-radius: 100%;
                            border: solid 2px #000;
                            background: #fff;
                            margin-right: 12px;
                            padding-bottom: 4px;
                        }

                        &>img {
                            position: absolute;
                            right: 0;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                }

                button {
                    cursor: pointer;
                    width: 100%;
                }
            }

            .QuizMultiplePath__results_links {

                margin-top: 30px;
                display: flex;
                flex-direction: column;

                >.hyperLink {
                    display: block;
                    line-height: 2em;
                }


            }

            .Button {
                display: flex;
                line-height: 2em;
                background-color: #000;
                color: #fff;
                margin-top: 30px;
            }
        }
    }

    // exp
    .list-leave-active {
        position: absolute;
    }



    @include mobile-only {

        padding-top: 80px
    }

}
</style>